import React, {Component} from 'react'
import { Route } from "react-router-dom";
import Parse from 'parse';
import TransitionGroup from "react-transition-group/TransitionGroup";
import AnimatedSwitch from "./utils/animated_switch";
import Header from "./components/header";
import Footer from "./components/footer";
import Home from "./pages/home";
import Contact from "./pages/contact";
import Services from "./pages/services";
import Workshops from "./pages/workshops";
import Formoms from "./pages/formoms";
import Testimonials from "./pages/testimonials";
import ThankYou from "./pages/thankyou";
import About from "./pages/about";
import Online from "./pages/online";
import Videos from "./pages/videos";
import Posture from "./pages/posture";
import KitchenSink from "./pages/kitchenSink";

export class Layout extends Component {
  constructor(props) {
      super(props);
      this.state = ({

			})
  }
  componentDidMount = () =>{
    document.getElementsByTagName("main")[0].scrollTop = 0;
  }
  render() {
    return(
      <div>
        { this.props.children }
        <Footer />
      </div>
    )
  }
}

export default class App extends Component {
  constructor() {
      super();
			this.state = {}
  }
  componentDidMount = () =>{

  }

  render() {
   return (
	<Route
		render={({ location }) => (
      <div>
        <Header/>
        <TransitionGroup component="main">
          <AnimatedSwitch key={location.key} location={location}>
            <Route exact path="/" render={props => (<Layout><Home /></Layout>)} />
            <Route exact path="/about" render={props => (<Layout><About /></Layout>)} />
            <Route exact path="/contact" render={props => (<Layout><Contact /></Layout>)} />
            <Route exact path="/services" render={props => (<Layout><Services /></Layout>)} />
            <Route exact path="/testimonials" render={props => (<Layout><Testimonials /></Layout>)} />
            <Route exact path="/formoms" render={props => (<Layout><Formoms /></Layout>)} />
            <Route exact path="/online" render={props => (<Layout><Online /></Layout>)} />
            <Route exact path="/posture" render={props => (<Layout><Posture /></Layout>)} />
            <Route exact path="/videos" render={props => (<Layout><Videos /></Layout>)} />
            <Route exact path="/thankyou" render={props => (<Layout><ThankYou /></Layout>)} />
          </AnimatedSwitch>
        </TransitionGroup>
      </div>
		)}
 />
	 );
  }
}



// WEBPACK FOOTER //
// ./src/app.js